export default {
  name: 'marking--withdrawalType',
};